/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import { SkeletonText } from '@carbon/react';

var TagAreaSkeleton = function TagAreaSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "cpc--tag-area-skeleton"
  }, /*#__PURE__*/React.createElement(SkeletonText, {
    heading: true
  }));
};
var TagAreaSkeleton$1 = TagAreaSkeleton;

export { TagAreaSkeleton$1 as default };
